import type {
  PinOnImageResult,
  CorrectArea,
} from '@core-api/presentation/types/response';
import type { SlidePreviewResultsInputs } from '../../types';

const isWithinCorrectArea = (
  x: number,
  y: number,
  correctArea: CorrectArea | null,
) => {
  return (
    !correctArea ||
    (x >= correctArea.left &&
      x <= correctArea.right &&
      y >= correctArea.top &&
      y <= correctArea.bottom)
  );
};

export const getPreviewResultsIteration = ({
  previous = [],
  iteration,
  extras: { correctArea },
}: SlidePreviewResultsInputs<PinOnImageResult>): PinOnImageResult[] => {
  if (iteration === 0) {
    return [...previous];
  }

  const minPins = 1;
  const maxPins = 5;

  const x = Math.random();
  const y = Math.random();
  const responseCount = Math.floor(Math.random() * maxPins) + minPins;

  const isCorrect = isWithinCorrectArea(x, y, correctArea);

  const newResult: PinOnImageResult = {
    x,
    y,
    responseCount,
    correctAnswerStatus: isCorrect ? 'correct' : 'incorrect',
  };

  return [...previous, newResult];
};
